import {
  SAVE_CONDITION_REPORT_FAILURE,
  SAVE_CONDITION_REPORT_SUCCESS,
  SAVE_CONDITION_REPORT_REQUEST,
  FETCH_CONDITION_REPORTS_REQUEST,
  FETCH_CONDITION_REPORTS_SUCCESS,
  FETCH_CONDITION_REPORTS_FAILURE,
  FETCH_CONDITION_REPORT_REQUEST,
  FETCH_CONDITION_REPORT_SUCCESS,
  FETCH_CONDITION_REPORT_FAILURE,
  DELETE_CONDITION_REPORT_REQUEST,
  DELETE_CONDITION_REPORT_SUCCESS,
  DELETE_CONDITION_REPORT_FAILURE,
  FETCH_CONDITION_COMPLETE_REQUEST,
  FETCH_CONDITION_COMPLETE_SUCCESS,
  FETCH_CONDITION_COMPLETE_FAILURE,
} from './types';

const INITIAL_STATE = {
  conditionReports: [],
  conditionReport: null,
  conditionReportComplete: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CONDITION_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CONDITION_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        conditionReports: action.payload,
      };

    case FETCH_CONDITION_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        conditionReports: [],
      };
    case FETCH_CONDITION_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CONDITION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        conditionReport: action.payload,
      };

    case FETCH_CONDITION_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        conditionReport: null,
      };
    case SAVE_CONDITION_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_CONDITION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_CONDITION_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case DELETE_CONDITION_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_CONDITION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_CONDITION_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_CONDITION_COMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CONDITION_COMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        conditionReportComplete: action.payload,
      };

    case FETCH_CONDITION_COMPLETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        conditionReportComplete: null,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
